import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function DataDriven() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Data Driven Decision Making</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Data Intelligence</div>
                                <h1 className="prod-hero-title">Data Driven <span>Decision Making</span></h1>
                                <p>With digital transformation accelerating exponentially, companies need greater insights, real-time performance reporting and predictive analysis to drive operational efficiency across every line of business.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Data Driven" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/data-driven.webp')} alt="Data Driven Decision Making" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Overview</div>
                                <h2>Intelligent Data-Driven Organizations</h2>
                                <p>They require greater insights, real-time performance reporting and predictive analysis to drive greater operational efficiency and performance while increasing visibility across every line of business.</p>
                                <p>Remote and hybrid working models have become the norm — pushing companies to become more flexible, digital-first and connected. Digital tools and the ability to break down silos have become critical to long-term success.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4 Solutions */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Solutions</div>
                        <h2 className="prod-section-title">Data Intelligence <span>Solutions</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Putting data into insights — empowering decision makers across your organization</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-bar-chart"></i></div>
                            <h4>Greatest Business Value from Data</h4>
                            <p>Cloud Mind helps decision makers make adequate decisions through Power Apps. Turn ideas into solutions — build custom apps that solve business challenges and automate organizational processes.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-line-chart"></i></div>
                            <h4>Consulting for Scalable Apps</h4>
                            <p>Leverage analytics platforms to turn raw data into actionable insights, rich visual reports, and interactive dashboards — bridging the gap between data and decision-making.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-cogs"></i></div>
                            <h4>Seamless Implementation</h4>
                            <p>Expert services to simplify the implementation and integration of data services — planning, designing, and testing in your environment with proven methodology.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-flask"></i></div>
                            <h4>Data Science &amp; Analytics</h4>
                            <p>Advanced data science capabilities to uncover hidden patterns, predict outcomes, and generate strategic insights that drive competitive advantage across your business.</p>
                            <div className="prod-feature-number">04</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 2 Key Capabilities */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Key Capabilities</div>
                        <h2 className="prod-section-title">Powering Your <span>Digital Transformation</span></h2>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="prod-feature-card" style={{ height: '100%' }}>
                                <div className="prod-feature-icon">
                                    <img src={require('../../../assets/images/services/products/expt-1.webp')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                                </div>
                                <h4>Bring Your Team Together</h4>
                                <p>With Microsoft Dynamics 365 Business Central, bring together every aspect of your business using a cloud solution. Migration ensures fast mobility to Cloud technology and brings visibility and coherence. As trusted Microsoft Partners, we deliver measurable results with data-driven insights.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-feature-card" style={{ height: '100%' }}>
                                <div className="prod-feature-icon">
                                    <img src={require('../../../assets/images/services/products/expt-2.webp')} alt="" style={{ width: 28, height: 28, filter: 'brightness(0) invert(1)' }} />
                                </div>
                                <h4>Harnessing the Power of Low-Code</h4>
                                <p>The era of low-code and no-code tools has arrived. Non-IT departments and individuals can now build their own technologies to solve their own problems — without needing deep technical expertise. CLOUD MIND enables your entire organization to innovate.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Become a Data-Driven Organization?</h3>
                            <p>Let CLOUD MIND help you unlock the full potential of your data for smarter, faster decision-making.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
